var _path, _circle, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPercent2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 54,
    viewBox: "0 0 24 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 53.0174H4.5C3.66667 52.9786 1.8 51.9242 1 48.0174V19.0174C1 18.6453 1.3 17.6242 2.5 16.5174L9.5 10.0174C10.3333 9.24965 12.5 8.17478 14.5 10.0174C16.8333 12.1841 20.3 15.3174 21.5 16.5174C22.7 17.7174 23 18.6841 23 19.0174V48.0174C22.2 52.0174 20.3333 53.0174 19.5 53.0174Z",
    fill: "#E72626",
    stroke: "#E72626",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.45463,
    cy: 2.45463,
    r: 2.45463,
    transform: "matrix(-1 0 0 1 14.3655 14.2288)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9376 17.3452C11.6692 17.4245 11.3854 17.2782 11.3038 17.0184C11.2221 16.7586 11.3735 16.4837 11.642 16.4043L11.9376 17.3452ZM8.35757 12.5608L8.20042 13.0287L7.23425 12.7255L7.39139 12.2576L8.35757 12.5608ZM11.642 16.4043C15.0376 15.4005 17.0141 13.1006 17.9511 10.5813C18.8956 8.04189 18.7704 5.31241 17.9877 3.52241C17.5957 2.62582 17.0652 2.02216 16.4866 1.7513C15.9389 1.49494 15.2613 1.49593 14.4363 1.98762C13.5909 2.49151 12.613 3.50325 11.5681 5.22817C10.5271 6.94658 9.43942 9.3395 8.35757 12.5608L7.39139 12.2576C8.48764 8.99337 9.60227 6.52976 10.6919 4.73118C11.7775 2.93913 12.8585 1.77345 13.9045 1.15005C14.9708 0.514465 16.017 0.438317 16.9297 0.865553C17.8114 1.27829 18.4778 2.11896 18.9234 3.13802C19.816 5.17934 19.9287 8.16645 18.907 10.9137C17.8777 13.681 15.6837 16.2377 11.9376 17.3452L11.642 16.4043Z",
    fill: "url(#paint0_linear_9558_40403)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9558_40403",
    x1: 10.7141,
    y1: 15.9408,
    x2: 8.43945,
    y2: 15.6353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent2);
export default __webpack_public_path__ + "static/media/percent2.616c4f3c1e1f9b7fb390a38cbbfadca8.svg";
export { ForwardRef as ReactComponent };